import React from "react";
import { NEUTRAL, STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";
import { formatCount } from "../../../utils/numberFormat";

const DonutChart = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    { name: "Completed", value: 0, color: STATUS_COLORS.completed },
    { name: "In Progress", value: 0, color: STATUS_COLORS.underConstruction },
    { name: "Delayed", value: 0, color: getPaletteColor(4) },
    { name: "Postponed", value: 0, color: getPaletteColor(2) },
    { name: "Cancelled", value: 0, color: getPaletteColor(5) },
  ];

  if (data && data.length > 0) {
    data.forEach((item) => {
      const existingIndex = allStatusData.findIndex(
        (status) => status.name === item.name
      );
      if (existingIndex !== -1) {
        allStatusData[existingIndex].value = item.value;
      }
    });
  }

  const total = allStatusData.reduce((sum, item) => sum + item.value, 0);

  const radius = 40;
  const strokeWidth = 8;
  const center = radius + strokeWidth;
  const circumference = 2 * Math.PI * radius;

  let cumulativePercentage = 0;

  const leftSideData = allStatusData.filter(
    (item) => item.name === "Completed" || item.name === "In Progress"
  );
  const rightSideData = allStatusData.filter(
    (item) => item.name === "Delayed" || item.name === "Postponed" || item.name === "Cancelled"
  );


  return (
    <div className="flex items-center justify-center gap-3">
      <div className="flex flex-col space-y-2">
        {leftSideData.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-xs text-left"
          >
            <div
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{ backgroundColor: item.color }}
            ></div>
            <div className="flex flex-col min-w-0">
              <span className="font-bold text-gray-800">
                {formatCount(item.value)}
              </span>
              <span className="text-gray-500 text-[10px] leading-tight">
                {item.name}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div
        className="relative flex-shrink-0"
        style={{ width: center * 2, height: center * 2 }}
      >
        <svg
          width={center * 2}
          height={center * 2}
          className="transform -rotate-90"
        >
          <circle
            cx={center}
            cy={center}
            r={radius}
            stroke={NEUTRAL.track}
            strokeWidth={strokeWidth}
            fill="transparent"
          />

          {allStatusData
            .filter((item) => item.value > 0)
            .map((item, index) => {
              const percentage = total > 0 ? (item.value / total) * 100 : 0;
              const strokeDasharray = `${(percentage / 100) * circumference} ${circumference}`;
              const strokeDashoffset = -((cumulativePercentage / 100) * circumference);

              const segment = (
                <circle
                  key={index}
                  cx={center}
                  cy={center}
                  r={radius}
                  stroke={item.color}
                  strokeWidth={strokeWidth}
                  fill="transparent"
                  strokeDasharray={strokeDasharray}
                  strokeDashoffset={strokeDashoffset}
                  className="transition-all duration-300"
                />
              );

              cumulativePercentage += percentage;
              return segment;
            })}
        </svg>

        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-lg font-bold text-gray-800">{formatCount(centerValue)}</div>
          <div className="text-xs text-gray-600">{centerLabel}</div>
        </div>
      </div>

      <div className="flex flex-col space-y-2">
        {rightSideData.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-xs text-left"
          >
            <div
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{ backgroundColor: item.color }}
            ></div>
            <div className="flex flex-col min-w-0">
              <span className="font-bold text-gray-800">
                {formatCount(item.value)}
              </span>
              <span className="text-gray-500 text-[10px] leading-tight">
                {item.name}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;